// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// // import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
// import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as BagPlusFill } from "bootstrap-icons/icons/bag-plus-fill.svg";
// import { ReactComponent as LightningChargeFill } from "bootstrap-icons/icons/lightning-charge-fill.svg";
// import { ReactComponent as DeleteFlashIcon } from "bootstrap-icons/icons/trash.svg";
// import { ReactComponent as EditFlashIcon } from "bootstrap-icons/icons/pencil.svg";
// import { ReactComponent as PlusCircleFill } from "bootstrap-icons/icons/plus-circle-fill.svg";
// import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
// import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
// import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// // import { ReactComponent as Calendar } from "bootstrap-icons/icons/calendar.svg";
// import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
// // import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// import Spinner from "../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
// import { handleError } from "../../components/utils/AuthenticationCheck";
// import { AuthContext } from "../../AuthProvider/AuthProvider";
// import formatDate from "../../components/utils/DateFormatter";
// import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";


// const ProductStockList = () => {
//   const [productStockList, setProductStockList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [loadingCSV, setLoadingCSV] = useState(false);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [confirmationLoading, setConfirmationLoading] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState("available");
//   const navigate = useNavigate();

//   // const [expandedRows, setExpandedRows] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [perPage, setPerPage] = useState(10);

//   // const [activeRowId, setActiveRowId] = useState(null);
//   // const [selectedProductStock, setSelectedProductStock] = useState(null);
//   const [flashSales, setFlashSales] = useState(null);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedOwnerType, setSelectedProductOwnerType] = useState("");
//   const { permissions } = useContext(AuthContext);
//   // console.log("this is permissions", permissions);

//   // Date filter state
//   const [filters, setFilters] = useState({
//     start_date: "",
//     end_date: "",
//   });

//   // Handle filter changes
//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = (newPerPage, page) => {
//     setPerPage(newPerPage);
//     setCurrentPage(page);
//   };


//   // Clear date filters
//   const handleClearDates = () => {
//     setFilters({
//       start_date: "",
//       end_date: "",
//     });
//     toast.success("Date filters cleared");
//   };

//   // Check if both dates are selected
//   const areDatesSelected = filters.start_date && filters.end_date;



//   // Fetch product stock
//   useEffect(() => {
//     const fetchProductStockList = async () => {
//       setLoading(true);
//       try {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) {
//           throw new Error("No access token found.");
//         }

//         const response = await axios.get(ApiServices.getAllProductsStock, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message, data } = response.data;
//         if (status === 200) {
//           // Filter to only show available products
//           const availableProducts = data.filter(
//             (product) => product.status === "available"
//           );
//           setProductStockList(availableProducts);
//           toast.success(message, { toastId: "product-stock-fetch-success" });
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProductStockList();
//   }, [navigate]);

//   // Handle delete flash sales
//   const handleDeleteCategory = async (stock_id) => {
//     const formData = { stock_id };
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }

//       const response = await axios.delete(ApiServices.removeProductStock, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         data: formData,
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         const updatedProductStock = productStockList.filter(
//           (product) => product.stock_id !== stock_id
//         );
//         setProductStockList(updatedProductStock);
//         toast.error(message);
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle delete category
//   const handleDeleteflash = async (flash_sale_id) => {
//     const formData = { flash_sale_id };
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }

//       const response = await axios.delete(ApiServices.removeFlashsales, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         data: formData,
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         const updatedProductStock = productStockList.filter(
//           (product) => product.flash_sale?.flash_sale_id !== flash_sale_id
//         );
//         setProductStockList(updatedProductStock);
//         toast.error(message);
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Confirm delete
//   const handleDeleteConfirmation = (flash_sale_id) => {
//     setConfirmationLoading(true);
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       setConfirmationLoading(false);
//       if (result.isConfirmed) {
//         handleDeleteflash(flash_sale_id);
//       }
//     });
//   };

//   // Filter data by name
//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   // Function to format permission text
//   const formatText = (text) => {
//     let formattedText = text.replace(/_/g, " ");
//     formattedText = formattedText
//       .toLowerCase()
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//     return formattedText;
//   };

//   const ExpandableComponent = ({ data }) => {
//     // Add console.log to debug
//     console.log("Expandable component data:", data);
//     console.log("Current permissions:", permissions);
//     console.log("Flash sale data:", data.flash_sale);
//     console.log("Product status:", data.status);
//     console.log("Store ID:", data.store_id);

//     return (
//       <div className="flex justify-start p-4 bg-gray-50">
//         {data.status === "available" && (
//           <div className="flex flex-wrap gap-2">
//             {/* Flash Sale Actions */}
//             {data.flash_sale?.status === "active" ? (
//               permissions.some(permission => permission.name === "flash_sales.edit") && (
//                 <div className="relative mx-2 my-2 group">
//                   <Link
//                     to="/admin/flash/sales/update"
//                     state={{ productStock: data, flash_sale: data }}
//                   >
//                     <EditFlashIcon className="w-5 h-5 text-dash5" />
//                   </Link>
//                   <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                     Edit Flash
//                   </div>
//                 </div>
//               )
//             ) : (
//               permissions.some(permission => permission.name === "flash_sales.create") && (
//                 <div className="relative mx-2 my-2 group">
//                   <Link
//                     to="/admin/flash/sales/create"
//                     state={{ productStock: data }}
//                   >
//                     <LightningChargeFill className="w-5 h-5 text-red1" />
//                   </Link>
//                   <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                     Add Flash Sales
//                   </div>
//                 </div>
//               )
//             )}
//             {/* Delete Flash Sale Button */}
//             {data.flash_sale?.status === "active" &&
//               permissions.some(permission => permission.name === "flash_sales.delete") && (
//                 <div className="relative mx-2 my-2 group">
//                   <button
//                     onClick={() => handleDeleteConfirmation(data.flash_sale?.flash_sale_id)}
//                   >
//                     <DeleteFlashIcon className="w-5 h-5 text-red1" />
//                   </button>
//                   <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                     Delete Flash
//                   </div>
//                 </div>
//               )}

//             {permissions.some(permission => permission.name === 'stock.view') && (
//               <div className="relative mx-2 my-2 group">
//                 <Link
//                   to="/admin/product/stock/details"
//                   state={{ stock_id: data.stock_id, productStock: data }}
//                 >
//                   <Eye className="w-5 h-5 text-darkGreen3" />
//                 </Link>
//                 <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                   Details
//                 </div>
//               </div>
//             )}

//             {permissions.some(permission => permission.name === 'stock.edit') && (
//               <div className="relative mx-2 my-2 group">
//                 <Link
//                   to="/admin/product/stock/edit"
//                   state={{ productStock: data }}
//                 >
//                   <PencilSquare className="w-5 h-5 text-dash4" />
//                 </Link>
//                 <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                   Edit
//                 </div>
//               </div>
//             )}

//             {permissions.some(permission => permission.name === 'image.add') && (
//               <div className="relative mx-2 my-2 group">
//                 <Link
//                   to="/admin/product/stock/images"
//                   state={{ productStock: data }}
//                 >
//                   <PlusSquareFill className="w-5 h-5 text-orange1" />
//                 </Link>
//                 <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                   Add Images
//                 </div>
//               </div>
//             )}

//             {permissions.some(permission => permission.name === 'stock.supply') && (
//               <div className="relative mx-2 my-2 group">
//                 <Link
//                   to="/admin/product/stock/add/supply"
//                   state={{ productStock: data }}
//                 >
//                   <BagPlusFill className="w-5 h-5 text-darkGreen2" />
//                 </Link>
//                 <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                   Add Supply
//                 </div>
//               </div>
//             )}

//             {permissions.some(permission => permission.name === 'product.create') && (
//               <div className="mx-2 my-2 group relative">
//                 {data.store_id !== 1 && (
//                   <Link
//                     to="/admin/product/stock/profit"
//                     state={{ productStock: data }}
//                   >
//                     <PlusCircleFill className="w-5 h-5 text-dash4" />
//                     <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//                       Profit
//                     </div>
//                   </Link>
//                 )}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const columns = [
//     {
//       name: "Name",
//       sortable: true,
//       width: "200px",
//       cell: (row) => (
//         <div>
//           <span className="block font-bold">
//             {row.name ? row.name.toUpperCase() : "NOT AVAILABLE"}
//           </span>
//           <span className="px-3 py-0.5 rounded-md text-xs bg-orange1 text-lGrey2">
//             {row.sku ? row.sku.toLowerCase() : "NOT AVAILABLE"}
//           </span>
//         </div>
//       ),
//     },
//     {
//       name: "Product Owner",
//       selector: (row) => (row.product_status ? row.store_id : "NOT AVAILABLE"),
//       sortable: true,
//       cell: (row) => {
//         let backgroundColor = "grey";
//         let text = "NOT AVAILABLE";

//         if (row.store_id === 1) {
//           backgroundColor = "#1D9E34";
//           text = "Admin";
//         } else if (row.store_id && row.store_id !== 1) {
//           backgroundColor = "#4373fc";
//           text = "Vendor";
//         }

//         return (
//           <span
//             style={{
//               backgroundColor: backgroundColor,
//               color: "white",
//               padding: "5px 10px",
//               borderRadius: "5px",
//               display: "inline-block",
//             }}
//           >
//             {text}
//           </span>
//         );
//       },
//       width: "180px",
//     },
//     {
//       name: "Price",
//       selector: (row) => CurrencyFormatter(row.price) || "0.00",
//       sortable: true,
//       width: "180px",
//     },
//     {
//       name: "Qty",
//       selector: (row) => row.quantity || "0",
//       sortable: true,
//       width: "100px",
//     },
//     {
//       name: "Aval.Qty",
//       selector: (row) => row.avail_quantity || "0",
//       sortable: true,
//       width: "100px",
//     },
//     {
//       name: "Discount",
//       selector: (row) => `${row.discount_percentage}%` || "0.00%",
//       sortable: true,
//       width: "100px",
//     },
//     {
//       name: "Profit",
//       selector: (row) => {
//         const profitValue = parseFloat(row.profit);
//         if (isNaN(profitValue)) return "0.00%";
//         if (row.profit_type === "percentage") {
//           return `${profitValue}%`;
//         }
//         return `${CurrencyFormatter(profitValue)}`;
//       },
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Sold Qty",
//       selector: (row) => row.sold_quantity || "0",
//       sortable: true,
//       width: "100px",
//     },
//     {
//       name: "Status",
//       selector: (row) =>
//         row.status ? formatText(row.status).toUpperCase() : "NOT AVAILABLE",
//       sortable: true,
//       cell: (row) => {
//         let color = "grey";
//         if (row.status === "available") {
//           color = "green";
//         } else if (row.status === "out_of_stock") {
//           color = "red";
//         } else if (row.status === "discontinued") {
//           color = "blue";
//         }
//         return (
//           <span style={{ color: color }}>
//             {row.status
//               ? formatText(row.status).toUpperCase()
//               : "NOT AVAILABLE"}
//           </span>
//         );
//       },
//       width: "150px",
//     },
//     {
//       name: "Product Status",
//       selector: (row) =>
//         row.product_status ? row.product_status.toUpperCase() : "NOT AVAILABLE",
//       sortable: true,
//       cell: (row) => {
//         let color = "grey";
//         if (row.product_status === "active") {
//           color = "green";
//         } else if (row.product_status === "inactive") {
//           color = "red";
//         }
//         return (
//           <span style={{ color: color }}>
//             {row.product_status
//               ? row.product_status.toUpperCase()
//               : "NOT AVAILABLE"}
//           </span>
//         );
//       },
//       width: "150px",
//     },
//     {
//       name: "Last Restock Date",
//       selector: (row) => row.last_restocked_at ? formatDate(row.last_restocked_at) : "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Date Created",
//       selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//   ];

//   //selct user type
//   const handleProductOwnerTypeSelect = (type) => {
//     setSelectedProductOwnerType(type);
//     setIsDropdownOpen(false);
//   };

//   //filter data
//   // const filteredItems = productStockList.filter((item) => {
//   //   const matchesFilterText = Object.values(item).some(
//   //     (value) =>
//   //       typeof value === "string" &&
//   //       value.toLowerCase().includes(filterText.toLowerCase())
//   //   );

//   //   const matchesProductOwnerType =
//   //     !selectedOwnerType ||
//   //     (selectedOwnerType === "admin" && item.store_id === 1) ||
//   //     (selectedOwnerType === "vendor" && item.store_id !== 1);

//   //   let matchesDateRange = true;
//   //   if (areDatesSelected) {
//   //     const itemDate = new Date(item.created_at);
//   //     const startDate = new Date(filters.start_date);
//   //     const endDate = new Date(filters.end_date);
//   //     endDate.setHours(23, 59, 59, 999);
//   //     matchesDateRange = itemDate >= startDate && itemDate <= endDate;
//   //   }

//   //   return matchesFilterText && matchesProductOwnerType && matchesDateRange;
//   // });


//   //filter data for avaialable product only
//   const filteredItems = productStockList.filter((item) => {
//     // First, only include available products
//     if (item.status !== "available") {
//       return false;
//     }

//     const matchesFilterText = Object.values(item).some(
//       (value) =>
//         typeof value === "string" &&
//         value.toLowerCase().includes(filterText.toLowerCase())
//     );

//     const matchesProductOwnerType =
//       !selectedOwnerType ||
//       (selectedOwnerType === "admin" && item.store_id === 1) ||
//       (selectedOwnerType === "vendor" && item.store_id !== 1);

//     let matchesDateRange = true;
//     if (areDatesSelected) {
//       const itemDate = new Date(item.created_at);
//       const startDate = new Date(filters.start_date);
//       const endDate = new Date(filters.end_date);
//       endDate.setHours(23, 59, 59, 999);
//       matchesDateRange = itemDate >= startDate && itemDate <= endDate;
//     }

//     return matchesFilterText && matchesProductOwnerType && matchesDateRange;
//   });

  

//   const data = filteredItems.map((productStock) => ({
//     last_restocked_at: productStock.last_restocked_at || "NOT AVAILABLE",
//     price: productStock.price || "0.00",
//     quantity: productStock.quantity || "0",
//     product_category: productStock.product_category || "NOT AVAILABLE",
//     sub_category: productStock.sub_category || "NOT AVAILABLE",
//     status: productStock.status || "NOT AVAILABLE",
//     category: productStock.category
//       ? productStock.category.toUpperCase()
//       : "NOT AVAILABLE",
//     sub_category_id: productStock.sub_category_id,
//     category_id: productStock.category_id,
//     name: productStock.name,
//     product_category_id: productStock.product_category_id,
//     product_status: productStock.product_status,
//     sku: productStock.sku,
//     stock_id: productStock.stock_id,
//     store_id: productStock.store_id,
//     store_name: productStock.store_name ? productStock.store_name.toUpperCase() : "NOT AVAILABLE",
//     product_id: productStock.product_id,
//     flash_sale: productStock.flash_sale,
//     flash_sale_id: productStock.flash_sale_id,
//     quantity: productStock.quantity,
//     sold_quantity: productStock.sold_quantity,
//     avail_quantity: productStock.avail_quantity,
//     discount_percentage: productStock.discount_percentage,
//     is_serialized: productStock.is_serialized,
//     approved: productStock.approved,
//     profit: productStock.profit,
//     profit_type: productStock.profit_type,
//     super_approval: productStock.super_approval,
//     created_at: productStock.created_at,
//     // status: productStock.status,
//   }));

//   const sortedData = [...data].sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);
//     return dateB - dateA;
//   });

//   // Handle CSV Download - Server-side filtered by date
//   const handleDownloadCSV = async () => {
//     if (!areDatesSelected) {
//       toast.error("Please select both start and end dates to download CSV");
//       return;
//     }

//     const startDate = new Date(filters.start_date);
//     const endDate = new Date(filters.end_date);

//     if (startDate > endDate) {
//       toast.error("Start date must be before end date");
//       return;
//     }

//     const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
//     if (daysDiff > 365) {
//       toast.error("Date range cannot exceed 1 year");
//       return;
//     }

//     setLoadingCSV(true);

//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;

//       if (!token) {
//         toast.error("No access token found");
//         return;
//       }

//       const downloadPayload = {
//         start_date: filters.start_date,
//         end_date: filters.end_date,
//         download: 1,
//       };

//       const startDateFormatted = filters.start_date.replace(/-/g, '_');
//       const endDateFormatted = filters.end_date.replace(/-/g, '_');
//       const filename = `product_stock_${startDateFormatted}_to_${endDateFormatted}.csv`;

//       await downloadCSVFromApi(
//         ApiServices.getAllProductsStock,
//         downloadPayload,
//         token,
//         {
//           filename: filename,
//           columnsToRemove: [],
//           maxRows: 50000
//         }
//       );

//     } catch (error) {
//       handleError(error, navigate);
//       if (error.message && error.message.includes("CSV")) {
//         toast.error("Failed to process CSV file");
//       } else if (error.message && error.message.includes("network")) {
//         toast.error("Network error during download");
//       }
//     } finally {
//       setLoadingCSV(false);
//     }
//   };

//   return (
//     <div>
//       <MainLayouts>
//         <div className="sm:rounded-lg py-6 w-full">
//           <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               {/* DESKTOP VERSION */}
//               <div className="hidden md:flex items-center justify-between">
//                 <div>
//                   <ol className="list-none p-0 inline-flex mb-2">
//                     <li className="flex items-center">
//                       <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                         Stock Product
//                       </p>
//                       <ChevronRightIcon />
//                     </li>
//                     <li className="flex items-center">
//                       <p className="text-orange1">List</p>
//                     </li>
//                   </ol>
//                 </div>
//                 <div className="my-2 flex items-center space-x-3">
//                   {/* Select Options Button */}
//                   <div className="relative w-full md:w-auto flex-shrink-0 m-1">
//                     <div>
//                       <button
//                         type="button"
//                         className="bg-darkGreen3 inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-dGrey3"
//                         id="menu-button"
//                         aria-expanded={isDropdownOpen}
//                         aria-haspopup="true"
//                         onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//                       >
//                         Select Product Owner
//                         <svg
//                           className="-mr-1 h-5 w-5 text-gray-400"
//                           viewBox="0 0 20 20"
//                           fill="currentColor"
//                           aria-hidden="true"
//                         >
//                           <path
//                             fillRule="evenodd"
//                             d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
//                             clipRule="evenodd"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                     {isDropdownOpen && (
//                       <div
//                         className="absolute right-0 z-10 mt-2 w-full md:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
//                         role="menu"
//                         aria-orientation="vertical"
//                         aria-labelledby="menu-button"
//                       >
//                         <div
//                           className="py-1 rounded-md"
//                           role="none"
//                           style={{ backgroundColor: "white" }}
//                         >
//                           <button
//                             onClick={() => handleProductOwnerTypeSelect("admin")}
//                             className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                             role="menuitem"
//                           >
//                             Admin Product
//                           </button>
//                           <button
//                             onClick={() => handleProductOwnerTypeSelect("vendor")}
//                             className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                             role="menuitem"
//                           >
//                             Vendors Product
//                           </button>
//                           <div className="relative w-full md:w-auto flex-shrink-0">
//                             <button
//                               type="button"
//                               className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                               onClick={() => handleProductOwnerTypeSelect("")}
//                             >
//                               All Products
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                   <Link
//                     to="/admin/products/stock/create"
//                     className="text-dGrey3 bg-orange1 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
//                   >
//                     <PlusSquareFill className="mr-2 w-4 h-4" />
//                     Create Stock Product
//                   </Link>
//                 </div>
//               </div>

//               {/* MOBILE VERSION */}
//               <div className="md:hidden py-3">
//                 <div className="mb-3">
//                   <ol className="list-none p-0 inline-flex items-center">
//                     <li className="flex items-center">
//                       <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                         Stock Product
//                       </p>
//                       <ChevronRightIcon className="w-4 h-4" />
//                     </li>
//                     <li className="flex items-center">
//                       <p className="text-orange1">List</p>
//                     </li>
//                   </ol>
//                 </div>
//                 <div className="w-full">
//                   <div className="relative w-full md:w-auto flex-shrink-0 my-1">
//                     <div>
//                       <button
//                         type="button"
//                         className="bg-darkGreen3 inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-dGrey3"
//                         id="menu-button"
//                         aria-expanded={isDropdownOpen}
//                         aria-haspopup="true"
//                         onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//                       >
//                         Select Product Owner
//                         <svg
//                           className="-mr-1 h-5 w-5 text-gray-400"
//                           viewBox="0 0 20 20"
//                           fill="currentColor"
//                           aria-hidden="true"
//                         >
//                           <path
//                             fillRule="evenodd"
//                             d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
//                             clipRule="evenodd"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                     {isDropdownOpen && (
//                       <div
//                         className="absolute right-0 z-10 mt-2 w-full md:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
//                         role="menu"
//                         aria-orientation="vertical"
//                         aria-labelledby="menu-button"
//                       >
//                         <div
//                           className="py-1 rounded-md"
//                           role="none"
//                           style={{ backgroundColor: "white" }}
//                         >
//                           <button
//                             onClick={() => handleProductOwnerTypeSelect("admin")}
//                             className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                             role="menuitem"
//                           >
//                             Admin Product
//                           </button>
//                           <button
//                             onClick={() => handleProductOwnerTypeSelect("vendor")}
//                             className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                             role="menuitem"
//                           >
//                             Vendors Product
//                           </button>
//                           <div className="relative w-full md:w-auto flex-shrink-0">
//                             <button
//                               type="button"
//                               className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
//                               onClick={() => handleProductOwnerTypeSelect("")}
//                             >
//                               All Products
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                   <Link
//                     to="/admin/products/stock/create"
//                     className="w-full text-dGrey3 bg-orange1 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
//                   >
//                     <PlusSquareFill className="mr-2 w-4 h-4" />
//                     Create Stock Product
//                   </Link>
//                 </div>
//               </div>
//             </nav>
//           </section>

//           <div className="pb-4 bg-white dark:bg-gray-900">
//             {/* DESKTOP FILTERS */}
//             <div className="hidden md:flex flex-wrap items-center gap-3">
//               <div className="relative flex-grow min-w-[200px]">
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                   <input
//                     type="search"
//                     className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                     placeholder="Search ..."
//                     value={filterText}
//                     onChange={handleFilter}
//                   />
//                 </div>
//               </div>

//               <div className="min-w-[150px]">
//                 <div className="relative">
//                   <input
//                     type="date"
//                     value={filters.start_date}
//                     onChange={(e) => handleFilterChange("start_date", e.target.value)}
//                     className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
//                     max={filters.end_date || undefined}
//                     placeholder="Start Date"
//                   />
//                 </div>
//               </div>

//               <div className="min-w-[150px]">
//                 <div className="relative">
//                   <input
//                     type="date"
//                     value={filters.end_date}
//                     onChange={(e) => handleFilterChange("end_date", e.target.value)}
//                     className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
//                     min={filters.start_date || undefined}
//                     placeholder="End Date"
//                   />
//                 </div>
//               </div>

//               {areDatesSelected && (
//                 <div className="min-w-[120px]">
//                   <button
//                     onClick={handleClearDates}
//                     className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
//                   >
//                     <XCircle className="w-4 h-4" />
//                     Clear Dates
//                   </button>
//                 </div>
//               )}


//               <div className="min-w-[150px]">
//                 <select
//                   value={selectedStatus}
//                   onChange={(e) => setSelectedStatus(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
//                 >
//                   <option value="available">Available Only</option>
//                   <option value="pending">Pending Only</option>
//                   <option value="out_of_stock">Out of Stock</option>
//                   <option value="all">All Products</option>
//                 </select>
//               </div>
//               <div className="min-w-[160px]">
//                 <button
//                   onClick={handleDownloadCSV}
//                   className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
//                     ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
//                     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                     }`}
//                   disabled={!areDatesSelected || loadingCSV}
//                   title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
//                 >
//                   {loadingCSV ? (
//                     <>
//                       <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
//                       Downloading...
//                     </>
//                   ) : (
//                     <>
//                       <Download className="w-4 h-4" />
//                       Download CSV
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* MOBILE FILTERS */}
//             <div className="md:hidden flex flex-col gap-3">
//               <div className="w-full">
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                   <input
//                     type="search"
//                     className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//                     placeholder="Search ..."
//                     value={filterText}
//                     onChange={handleFilter}
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-2 gap-3">
//                 <div className="col-span-1">
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={filters.start_date}
//                       onChange={(e) => handleFilterChange("start_date", e.target.value)}
//                       className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
//                       placeholder="Start"
//                     />
//                   </div>
//                 </div>

//                 <div className="col-span-1">
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={filters.end_date}
//                       onChange={(e) => handleFilterChange("end_date", e.target.value)}
//                       className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
//                       placeholder="End"
//                     />
//                   </div>
//                 </div>

//                 {areDatesSelected && (
//                   <div className="col-span-2">
//                     <button
//                       onClick={handleClearDates}
//                       className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
//                     >
//                       <XCircle className="w-4 h-4" />
//                       Clear Dates
//                     </button>
//                   </div>
//                 )}

//                 <div className="col-span-2">
//                   <button
//                     onClick={handleDownloadCSV}
//                     className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
//                       ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
//                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                       }`}
//                     disabled={!areDatesSelected || loadingCSV}
//                   >
//                     {loadingCSV ? (
//                       <>
//                         <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
//                         <span className="ml-2">Downloading...</span>
//                       </>
//                     ) : (
//                       <>
//                         <Download className="w-4 h-4" />
//                         <span className="ml-2">Download CSV</span>
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Help text */}
//             <div className="hidden md:flex items-center justify-between mt-2">
//               {!areDatesSelected && (
//                 <p className="text-xs text-gray-500">
//                   Select start and end dates to enable download
//                 </p>
//               )}
//               {areDatesSelected && sortedData.length > 0 && (
//                 <p className="text-sm text-gray-600">
//                   Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
//                 </p>
//               )}
//             </div>

//             <div className="md:hidden mt-3">
//               {!areDatesSelected && (
//                 <p className="text-xs text-gray-500 text-center mb-2">
//                   Select start and end dates to enable download
//                 </p>
//               )}
//               {areDatesSelected && sortedData.length > 0 && (
//                 <p className="text-sm text-gray-600 text-center">
//                   Showing {sortedData.length} records
//                 </p>
//               )}
//             </div>
//           </div>

//           {loading ? (
//             <Spinner loading={loading} />
//           ) : (
//             <DataTable
//               columns={columns}
//               data={sortedData}
//               pagination
//               paginationPerPage={perPage}
//               paginationRowsPerPageOptions={[10, 20, 50, 100]}
//               onChangePage={handlePageChange}
//               onChangeRowsPerPage={handlePerRowsChange}
//               highlightOnHover
//               striped
//               customStyles={CustomStyles}
//               noDataComponent={<div>No Product found</div>}
//               expandableRows
//               expandableRowsComponent={ExpandableComponent}
//               expandableOnRowClicked={true}
//               expandableRowsHideExpander={false}
//             />
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default ProductStockList;


import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as BagPlusFill } from "bootstrap-icons/icons/bag-plus-fill.svg";
import { ReactComponent as LightningChargeFill } from "bootstrap-icons/icons/lightning-charge-fill.svg";
import { ReactComponent as DeleteFlashIcon } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as EditFlashIcon } from "bootstrap-icons/icons/pencil.svg";
import { ReactComponent as PlusCircleFill } from "bootstrap-icons/icons/plus-circle-fill.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// import { ReactComponent as Calendar } from "bootstrap-icons/icons/calendar.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
// import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import formatDate from "../../components/utils/DateFormatter";
import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";

const ProductStockList = () => {
  const [productStockList, setProductStockList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const navigate = useNavigate();

  // const [expandedRows, setExpandedRows] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  // const [activeRowId, setActiveRowId] = useState(null);
  // const [selectedProductStock, setSelectedProductStock] = useState(null);
  const [flashSales, setFlashSales] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOwnerType, setSelectedProductOwnerType] = useState("");
  const { permissions } = useContext(AuthContext);
  // console.log("this is permissions", permissions);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };


  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  // Fetch product stock
  useEffect(() => {
    const fetchProductStockList = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        const response = await axios.get(ApiServices.getAllProductsStock, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message, data } = response.data;
        if (status === 200) {
          // Filter out pending products - keep available and out_of_stock
          const activeProducts = data.filter(
            (product) => product.status === "available" || product.status === "out_of_stock"
          );
          setProductStockList(activeProducts);
          toast.success(message, { toastId: "product-stock-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchProductStockList();
  }, [navigate]);

  // Handle delete flash sales
  const handleDeleteCategory = async (stock_id) => {
    const formData = { stock_id };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const response = await axios.delete(ApiServices.removeProductStock, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        const updatedProductStock = productStockList.filter(
          (product) => product.stock_id !== stock_id
        );
        setProductStockList(updatedProductStock);
        toast.error(message);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  // Handle delete category
  const handleDeleteflash = async (flash_sale_id) => {
    const formData = { flash_sale_id };
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const response = await axios.delete(ApiServices.removeFlashsales, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        const updatedProductStock = productStockList.filter(
          (product) => product.flash_sale?.flash_sale_id !== flash_sale_id
        );
        setProductStockList(updatedProductStock);
        toast.error(message);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  // Confirm delete
  const handleDeleteConfirmation = (flash_sale_id) => {
    setConfirmationLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleDeleteflash(flash_sale_id);
      }
    });
  };

  // Filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Function to format permission text
  const formatText = (text) => {
    let formattedText = text.replace(/_/g, " ");
    formattedText = formattedText
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedText;
  };

  const ExpandableComponent = ({ data }) => {
    // Add console.log to debug
    // console.log("Expandable component data:", data);
    // console.log("Current permissions:", permissions);
    // console.log("Flash sale data:", data.flash_sale);
    // console.log("Product status:", data.status);
    // console.log("Store ID:", data.store_id);

    return (
      <div className="flex justify-start p-4 bg-gray-50">
        {/* Show actions for both available and out_of_stock products */}
        {(data.status === "available" || data.status === "out_of_stock") && (
          <div className="flex flex-wrap gap-2">
            {/* Flash Sale Actions */}
            {data.flash_sale?.status === "active" ? (
              permissions.some(permission => permission.name === "flash_sales.edit") && (
                <div className="relative mx-2 my-2 group">
                  <Link
                    to="/admin/flash/sales/update"
                    state={{ productStock: data, flash_sale: data }}
                  >
                    <EditFlashIcon className="w-5 h-5 text-dash5" />
                  </Link>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                    Edit Flash
                  </div>
                </div>
              )
            ) : (
              permissions.some(permission => permission.name === "flash_sales.create") && (
                <div className="relative mx-2 my-2 group">
                  <Link
                    to="/admin/flash/sales/create"
                    state={{ productStock: data }}
                  >
                    <LightningChargeFill className="w-5 h-5 text-red1" />
                  </Link>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                    Add Flash Sales
                  </div>
                </div>
              )
            )}
            {/* Delete Flash Sale Button */}
            {data.flash_sale?.status === "active" &&
              permissions.some(permission => permission.name === "flash_sales.delete") && (
                <div className="relative mx-2 my-2 group">
                  <button
                    onClick={() => handleDeleteConfirmation(data.flash_sale?.flash_sale_id)}
                  >
                    <DeleteFlashIcon className="w-5 h-5 text-red1" />
                  </button>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                    Delete Flash
                  </div>
                </div>
              )}

            {permissions.some(permission => permission.name === 'stock.view') && (
              <div className="relative mx-2 my-2 group">
                <Link
                  to="/admin/product/stock/details"
                  state={{ stock_id: data.stock_id, productStock: data }}
                >
                  <Eye className="w-5 h-5 text-darkGreen3" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                  Details
                </div>
              </div>
            )}

            {permissions.some(permission => permission.name === 'stock.edit') && (
              <div className="relative mx-2 my-2 group">
                <Link
                  to="/admin/product/stock/edit"
                  state={{ productStock: data }}
                >
                  <PencilSquare className="w-5 h-5 text-dash4" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                  Edit
                </div>
              </div>
            )}

            {permissions.some(permission => permission.name === 'image.add') && (
              <div className="relative mx-2 my-2 group">
                <Link
                  to="/admin/product/stock/images"
                  state={{ productStock: data }}
                >
                  <PlusSquareFill className="w-5 h-5 text-orange1" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                  Add Images
                </div>
              </div>
            )}

            {permissions.some(permission => permission.name === 'stock.supply') && (
              <div className="relative mx-2 my-2 group">
                <Link
                  to="/admin/product/stock/add/supply"
                  state={{ productStock: data }}
                >
                  <BagPlusFill className="w-5 h-5 text-darkGreen2" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                  Add Supply
                </div>
              </div>
            )}

            {permissions.some(permission => permission.name === 'product.create') && (
              <div className="mx-2 my-2 group relative">
                {data.store_id !== 1 && (
                  <Link
                    to="/admin/product/stock/profit"
                    state={{ productStock: data }}
                  >
                    <PlusCircleFill className="w-5 h-5 text-dash4" />
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                      Profit
                    </div>
                  </Link>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      name: "Name",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.name ? row.name.toUpperCase() : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md text-xs bg-orange1 text-lGrey2">
            {row.sku ? row.sku.toLowerCase() : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Product Owner",
      selector: (row) => (row.product_status ? row.store_id : "NOT AVAILABLE"),
      sortable: true,
      cell: (row) => {
        let backgroundColor = "grey";
        let text = "NOT AVAILABLE";

        if (row.store_id === 1) {
          backgroundColor = "#1D9E34";
          text = "Admin";
        } else if (row.store_id && row.store_id !== 1) {
          backgroundColor = "#4373fc";
          text = "Vendor";
        }

        return (
          <span
            style={{
              backgroundColor: backgroundColor,
              color: "white",
              padding: "5px 10px",
              borderRadius: "5px",
              display: "inline-block",
            }}
          >
            {text}
          </span>
        );
      },
      width: "180px",
    },
    {
      name: "Price",
      selector: (row) => CurrencyFormatter(row.price) || "0.00",
      sortable: true,
      width: "180px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity || "0",
      sortable: true,
      width: "100px",
    },
    {
      name: "Aval.Qty",
      selector: (row) => row.avail_quantity || "0",
      sortable: true,
      width: "100px",
    },
    {
      name: "Discount",
      selector: (row) => `${row.discount_percentage}%` || "0.00%",
      sortable: true,
      width: "100px",
    },
    {
      name: "Profit",
      selector: (row) => {
        const profitValue = parseFloat(row.profit);
        if (isNaN(profitValue)) return "0.00%";
        if (row.profit_type === "percentage") {
          return `${profitValue}%`;
        }
        return `${CurrencyFormatter(profitValue)}`;
      },
      sortable: true,
      width: "200px",
    },
    {
      name: "Sold Qty",
      selector: (row) => row.sold_quantity || "0",
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.status ? formatText(row.status).toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        let color = "grey";
        if (row.status === "available") {
          color = "green";
        } else if (row.status === "out_of_stock") {
          color = "red";
        } else if (row.status === "discontinued") {
          color = "blue";
        }
        return (
          <span style={{ color: color }}>
            {row.status
              ? formatText(row.status).toUpperCase()
              : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "150px",
    },
    {
      name: "Product Status",
      selector: (row) =>
        row.product_status ? row.product_status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        let color = "grey";
        if (row.product_status === "active") {
          color = "green";
        } else if (row.product_status === "inactive") {
          color = "red";
        }
        return (
          <span style={{ color: color }}>
            {row.product_status
              ? row.product_status.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "150px",
    },
    {
      name: "Last Restock Date",
      selector: (row) => row.last_restocked_at ? formatDate(row.last_restocked_at) : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Date Created",
      selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
  ];

  //selct user type
  const handleProductOwnerTypeSelect = (type) => {
    setSelectedProductOwnerType(type);
    setIsDropdownOpen(false);
  };

  //filter data based on filters
  const filteredItems = productStockList.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    const matchesProductOwnerType =
      !selectedOwnerType ||
      (selectedOwnerType === "admin" && item.store_id === 1) ||
      (selectedOwnerType === "vendor" && item.store_id !== 1);

    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);
      endDate.setHours(23, 59, 59, 999);
      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesProductOwnerType && matchesDateRange;
  });

  const data = filteredItems.map((productStock) => ({
    last_restocked_at: productStock.last_restocked_at || "NOT AVAILABLE",
    price: productStock.price || "0.00",
    quantity: productStock.quantity || "0",
    product_category: productStock.product_category || "NOT AVAILABLE",
    sub_category: productStock.sub_category || "NOT AVAILABLE",
    status: productStock.status || "NOT AVAILABLE",
    category: productStock.category
      ? productStock.category.toUpperCase()
      : "NOT AVAILABLE",
    sub_category_id: productStock.sub_category_id,
    category_id: productStock.category_id,
    name: productStock.name,
    product_category_id: productStock.product_category_id,
    product_status: productStock.product_status,
    sku: productStock.sku,
    stock_id: productStock.stock_id,
    store_id: productStock.store_id,
    store_name: productStock.store_name ? productStock.store_name.toUpperCase() : "NOT AVAILABLE",
    product_id: productStock.product_id,
    flash_sale: productStock.flash_sale,
    flash_sale_id: productStock.flash_sale_id,
    quantity: productStock.quantity,
    sold_quantity: productStock.sold_quantity,
    avail_quantity: productStock.avail_quantity,
    discount_percentage: productStock.discount_percentage,
    is_serialized: productStock.is_serialized,
    approved: productStock.approved,
    profit: productStock.profit,
    profit_type: productStock.profit_type,
    super_approval: productStock.super_approval,
    created_at: productStock.created_at,
    status: productStock.status,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  // Handle CSV Download - Server-side filtered by date
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `product_stock_${startDateFormatted}_to_${endDateFormatted}.csv`;

      await downloadCSVFromApi(
        ApiServices.getAllProductsStock,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [],
          maxRows: 50000
        }
      );

    } catch (error) {
      handleError(error, navigate);
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  return (
    <div>
      <MainLayouts>
        <div className="sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              {/* DESKTOP VERSION */}
              <div className="hidden md:flex items-center justify-between">
                <div>
                  <ol className="list-none p-0 inline-flex mb-2">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Stock Product
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">List</p>
                    </li>
                  </ol>
                </div>
                <div className="my-2 flex items-center space-x-3">
                  {/* Select Options Button */}
                  <div className="relative w-full md:w-auto flex-shrink-0 m-1">
                    <div>
                      <button
                        type="button"
                        className="bg-darkGreen3 inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-dGrey3"
                        id="menu-button"
                        aria-expanded={isDropdownOpen}
                        aria-haspopup="true"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        Select Product Owner
                        <svg
                          className="-mr-1 h-5 w-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                    {isDropdownOpen && (
                      <div
                        className="absolute right-0 z-10 mt-2 w-full md:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                      >
                        <div
                          className="py-1 rounded-md"
                          role="none"
                          style={{ backgroundColor: "white" }}
                        >
                          <button
                            onClick={() => handleProductOwnerTypeSelect("admin")}
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                            role="menuitem"
                          >
                            Admin Product
                          </button>
                          <button
                            onClick={() => handleProductOwnerTypeSelect("vendor")}
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                            role="menuitem"
                          >
                            Vendors Product
                          </button>
                          <div className="relative w-full md:w-auto flex-shrink-0">
                            <button
                              type="button"
                              className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                              onClick={() => handleProductOwnerTypeSelect("")}
                            >
                              All Products
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <Link
                    to="/admin/products/stock/create"
                    className="text-dGrey3 bg-orange1 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                  >
                    <PlusSquareFill className="mr-2 w-4 h-4" />
                    Create Stock Product
                  </Link>
                </div>
              </div>

              {/* MOBILE VERSION */}
              <div className="md:hidden py-3">
                <div className="mb-3">
                  <ol className="list-none p-0 inline-flex items-center">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Stock Product
                      </p>
                      <ChevronRightIcon className="w-4 h-4" />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">List</p>
                    </li>
                  </ol>
                </div>
                <div className="w-full">
                  <div className="relative w-full md:w-auto flex-shrink-0 my-1">
                    <div>
                      <button
                        type="button"
                        className="bg-darkGreen3 inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-dGrey3"
                        id="menu-button"
                        aria-expanded={isDropdownOpen}
                        aria-haspopup="true"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        Select Product Owner
                        <svg
                          className="-mr-1 h-5 w-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                    {isDropdownOpen && (
                      <div
                        className="absolute right-0 z-10 mt-2 w-full md:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                      >
                        <div
                          className="py-1 rounded-md"
                          role="none"
                          style={{ backgroundColor: "white" }}
                        >
                          <button
                            onClick={() => handleProductOwnerTypeSelect("admin")}
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                            role="menuitem"
                          >
                            Admin Product
                          </button>
                          <button
                            onClick={() => handleProductOwnerTypeSelect("vendor")}
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                            role="menuitem"
                          >
                            Vendors Product
                          </button>
                          <div className="relative w-full md:w-auto flex-shrink-0">
                            <button
                              type="button"
                              className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-white hover:text-darkGreen3"
                              onClick={() => handleProductOwnerTypeSelect("")}
                            >
                              All Products
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <Link
                    to="/admin/products/stock/create"
                    className="w-full text-dGrey3 bg-orange1 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
                  >
                    <PlusSquareFill className="mr-2 w-4 h-4" />
                    Create Stock Product
                  </Link>
                </div>
              </div>
            </nav>
          </section>

          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={filters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={filters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div>

              {areDatesSelected && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )}

              <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                  title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* MOBILE FILTERS */}
            <div className="md:hidden flex flex-col gap-3">
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange("start_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="Start"
                    />
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange("end_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="End"
                    />
                  </div>
                </div>

                {areDatesSelected && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearDates}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Dates
                    </button>
                  </div>
                )}

                <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                      ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Help text */}
            <div className="hidden md:flex items-center justify-between mt-2">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
                </p>
              )}
            </div>

            <div className="md:hidden mt-3">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500 text-center mb-2">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} records
                </p>
              )}
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              paginationPerPage={perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Product found</div>}
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              expandableOnRowClicked={true}
              expandableRowsHideExpander={false}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default ProductStockList;